import { ICustomer } from 'types/entities';
import { EntityService } from '../entity.service';


class CustomersService extends EntityService<ICustomer> {
  readonly entityName = 'customer';
}

export default new CustomersService();
